<mat-sidenav-container class="sidenav-container">
  <mat-sidenav [ngClass]=" getSideNavClass(opened)" [opened]="true" hasBackdrop="false" #drawer fixedInViewport="true"
    [attr.role]="'navigation'" mode="side">
    <mat-nav-list class="navigation-list" *ngFor="let item of navitems()">
      <mat-list-item [id]="'mat-list-item-' + item.label?.replaceAll(' ','-')" class="navigation-item"
        [ngClass]="item.active" (click)="select($event,item)">
        <p-overlayBadge [badgeDisabled]="getItemParentCount(item) < 1" badgeSize="small" severity="warn"
          [value]="getItemParentCount(item)">
          <button [id]="'button-' + item.label?.replaceAll(' ','-')" [ngClass]="'button-menu-item' +  item?.active">
            <mat-icon [ngClass]="item.iconClass" [title]="item.tooltip">
              {{item.icon}}
            </mat-icon>
          </button>
          <span *ngIf="opened == true" class="navigation-item-label">{{item.label}}</span>
        </p-overlayBadge>

      </mat-list-item>

      <div style="visibility: hidden; position: fixed;" [style.left]="contextMenuPosition.x" class="matpanel"
        [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu">
      </div>


      <mat-menu #contextMenu="matMenu" class="matpanel">
        <ng-template matMenuContent let-item="item">
          <div *ngFor="let subitem of item.children"  >
            <mat-list-item class="grid sublistItem" [id]="'mat-list-item-' + subitem.label?.replaceAll(' ','-')"
              (click)="select($event, subitem)">
              <p-overlay-badge [badgeDisabled]="!subitem.notificationCount || subitem.notificationCount == 0"
                badgeSize="small" severity="warn" [value]="subitem.notificationCount">
                <button [ngClass]="' col-2 button-menu-item' +  subitem?.active"
                  [id]="'button-' + subitem.label?.replaceAll(' ','-')">
                  <mat-icon [ngClass]="'subMenuIcon' + subitem?.active + ' '  + subitem.iconClass"
                    [title]="subitem.tooltip"> {{subitem.icon}} </mat-icon>
                </button>
                <span class="col mat-item-label"> {{subitem.label}} </span>

              </p-overlay-badge>
            </mat-list-item>

            @if(subitem.children && subitem.children.length > 0 && subitem.expanded)
            {
            <mat-list-item [ngStyle]="{'padding-left': 3 + 'rem'}" class=" sublistItem "
              [pTooltip]="subsubitem.tooltip" tooltipPosition="right"
              [id]="'mat-list-item-' + subsubitem.label?.replaceAll(' ','-')"
              *ngFor="let subsubitem of subitem.children" (click)="select($event, subsubitem)">
              <p-overlay-badge [badgeDisabled]="!subsubitem.notificationCount || subsubitem.notificationCount == 0"
                badgeSize="small" severity="warn" [value]="subsubitem.notificationCount">
                <button [ngClass]="' button-menu-item' +  subsubitem?.active"
                  [id]="'button-' + subsubitem.label?.replaceAll(' ','-')">
                  <mat-icon [ngClass]="'subMenuIcon' + subsubitem?.active + ' '  + subsubitem.iconClass"                   > {{subsubitem.icon}} </mat-icon>
                </button>
                <span class="mat-item-label"> {{subsubitem.label}} </span>
              </p-overlay-badge>
            </mat-list-item>
            }
          </div>
        </ng-template>
      </mat-menu>
      <mat-divider *ngIf="item.seperator" class="navigation-divider"></mat-divider>
    </mat-nav-list>
    <mat-nav-list style="bottom: 0rem; padding-bottom: 0rem !important; position: fixed;" class="navigation-list">

      <a mat-list-item class="menu-button" aria-label="Toggle sidenav" (click)="toggle()">
        <i [title]="opened == true ? 'Verkleinern' : 'Vergrößern'" class="material-icons">{{getIconInputOut()}}</i>
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content [ngClass]="getContentClass(opened)">
    <mat-toolbar class="sidenav-content-toolbar" *ngIf="headerHided === false">
      <div class="filler">
        <div class="grid">
          <div class="col-4">
            <a href="https://www.hugendubel.com/impressum.html" target="_blank"><img [src]="getLogoPath()"
                id="logo_hugendubel" style="padding: 1rem; width: 15rem; height: auto;" /></a>
          </div>
          <div class="col-2" style="padding-top: 1rem; ">
            <div id="headerstartseite" class="h1Header">{{getHeader()}} </div>
          </div>
          <div *ngIf="canNotification()" class="col-1" style="padding-top: 1rem; ">
            <div class="grid">
              <p-overlay-badge severity="warn" badgeSize="small" styleClass="p-badge-circle"
                [value]="notificationCountAll$ | async"
                [badgeDisabled]="!(notificationCountAll$ | async) || (notificationCountAll$ | async) == 0">
                <i (click)="gotoDashboard()" class="pi pi-bell" style="font-size: 1.6rem; "></i>
              </p-overlay-badge>
            </div>
          </div>
          <div class="col-2" style="padding-top: 0.5rem;">
            <p-menubar autoZIndex="true" appendTo="body" [model]="fontsizeitems"></p-menubar>
          </div>
          <div class="col-1" style="padding-top: 0.5rem; ">
            <p-inputSwitch [pTooltip]="'Hell/Dunkel'" (onChange)="changetheme($event)"
              [ngModel]="getSelectedstyleitem()?.name == 'dark'"></p-inputSwitch>
          </div>
          <div class="col" style="padding-top: 0.5rem; ">
            <p-menubar id="sessionmessage" appendTo="body" [pTooltip]="sessionMessage$ | async" [model]="items"
              tooltipPosition="left"></p-menubar>
          </div>
        </div>

      </div>
    </mat-toolbar>
    <button mat-icon-button aria-label="Verkleinern" (click)="headerToggle($event)"
      style="float: right; margin-right: 1rem; ">
      <mat-icon class="defaultIcon material-icons-outlined mat-icon ">{{headerToggledIcon()}}</mat-icon>
    </button>
    <router-outlet></router-outlet>


  </mat-sidenav-content>
</mat-sidenav-container>
